export default __webpack_public_path__ + "static/media/logotipo_blue.dc980f25.jpg";